module.exports = __webpack_public_path__ + "img/newmaintenancerequest.bf4b0a3.png";